import { ReactStateType } from "@xnav/types/src/frontend";
import { createContext, useState } from "react";
import { EditContent, SelectionType } from "@/pages/editor";
import { Content, NewContentItem, Section, SectionMeta } from "@xnav/types/src/common";
import { S3Client } from "@aws-sdk/client-s3";
import { DynamoDBClient } from "@aws-sdk/client-dynamodb";

export const StayUnsyncedContext = createContext<React.MutableRefObject<boolean> | undefined>(undefined)
export const SelectionReferenceContext = createContext<ReactStateType<NewContentItem | undefined>>([undefined, () => undefined])
export const SelectedContentContext = createContext<ReactStateType<EditContent | undefined> | undefined>(undefined)
export const SelectedSectionContext = createContext<ReactStateType<Section | undefined>>([undefined, () => undefined])
export const S3ClientContext = createContext<S3Client | undefined>(undefined)
export const DynamoClientContext = createContext<DynamoDBClient | undefined>(undefined)
export const ReferenceMediaContext = createContext<(mediaId: string) => void>(() => undefined)
export const DereferenceMediaContext = createContext<(mediaId: string) => void>(() => undefined)
export const ContentStructureContext = createContext<ReactStateType<SectionMeta[]>>([[], () => undefined])
export const DeletedContentContext = createContext<ReactStateType<string[]>>([[], () => undefined])
export const DeletedSectionsContext = createContext<ReactStateType<string[]>>([[], () => undefined])

export const EditorSyncContext = createContext<ReactStateType<boolean>>([false, () => undefined])
export const UploadJobsContext = createContext<[() => void, () => void]>([() => undefined, () => undefined])
export const ContentStoreContext = createContext<ReactStateType<Record<string, EditContent>>>([{}, () => undefined])
export const SetContentStoreContext = createContext<React.Dispatch<React.SetStateAction<Record<string, EditContent>>>>(() => undefined)
export const SectionStoreContext = createContext<ReactStateType<Record<string, Section>>>([{}, () => undefined])
export const StructureDirtyContext = createContext<ReactStateType<boolean>>([false, () => undefined])
export const NavCollapsedContext = createContext<ReactStateType<boolean>>([false, () => undefined])

// External store for fine-grained subscriptions without full tree re-renders
type ContentStoreListener = () => void;
const contentStoreListeners = new Set<ContentStoreListener>();
let globalContentStoreSnapshot: Record<string, EditContent> = {};

export function updateGlobalContentStore(store: Record<string, EditContent>) {
	globalContentStoreSnapshot = store;
	contentStoreListeners.forEach(listener => listener());
}

export function subscribeToContentStore(listener: ContentStoreListener) {
	contentStoreListeners.add(listener);
	return () => {
		contentStoreListeners.delete(listener);
	};
}

export function getContentStoreSnapshot(): Record<string, EditContent> {
	return globalContentStoreSnapshot;
}

